import { service } from '@ember/service';

import $ from 'jquery';

import type { Service } from 'webapp-types';
import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class CustomMetricsPopupQbTour extends TourBase {
	@service('billing') declare billingService: Service.Billing;

	static keyForPersistantDone = UserSettingsKey.CUSTOM_METRICS_POPUP_QB;

	get id(): string {
		return TourId.CUSTOM_METRICS_POPUP_QB;
	}

	override get keyForPersistantDone(): string {
		return CustomMetricsPopupQbTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				attachTo: function () {
					return $('.landing-side--custom-query .row.datasource .empty-placeholder');
				},
				doAction: () => {
					this.end();

					if (
						this.billingService.scriptsEnabled &&
						this.tourService.isEligibleForCustomMetricsPopupScriptTour
					) {
						this.tourService.initTour(TourId.CUSTOM_METRICS_POPUP_SCRIPT)?.start();
					}
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
